import Vue from 'vue'

// axios
import axios from 'axios'

// let site = window.location.origin
// if (site === 'http://localhost:8080') {
//   site = 'https://admin.pgsoft-th.cc'
// }
// const obj = {
//   site_admin: site,
//   // site_admin: 'http://pgsoft-th.ak11bet.com',
// }
// let endpoint = '';
// if(site.includes('bkbet')) {
//   endpoint = 'https://adminapi.bkbet365.cc/api';
// } else if(site.includes('pgsoft')) {
//   endpoint = 'https://api.pgbackend-th.com/api';
// } else {
//   endpoint = 'http://localhost:4040/api'
// }
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // baseURL: endpoint,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
  // headers: {
  //   'Content-Type': 'multipart/form-data',
  // },
})
// console.log(obj);
// const currentOrigin = window.origin
// let agApi = ''
// if (currentOrigin.includes('pgback')) {
//   agApi = 'https://ag.ak47-ag1ct.com'
// } else if (currentOrigin.includes('bk')) {
//   agApi = 'https://agbk.ak47-ag1ct.com'
// } else if (currentOrigin.includes('shibuya')) {
//   agApi = 'https://shibuya.ak47-ag1ct.com'
// } else if (currentOrigin.includes('narita')) {
//   agApi = 'https://agnari.ak47-ag1ct.com'
// } else if (currentOrigin.includes('friend')) {
//   agApi = 'https://pgfriend.ak47-ag1ct.com'
// } else if (currentOrigin.includes('pgth-backend')) {
//   agApi = 'https://pgsofts.ak47-ag1ct.com'
// } else if (currentOrigin.includes('pg4u')) {
//   agApi = 'https://pg4u.ak47-ag1ct.com'
// } else if (currentOrigin.includes('huayroot')) {
//   agApi = 'https://hroot.ak47-ag1ct.com'
// } else if (currentOrigin.includes('elisa')) {
//   agApi = 'https://elisa.ak47-ag1ct.com'
// } else if (currentOrigin.includes('luckycat')) {
//   agApi = 'https://cat.ak47-ag1ct.com'
// } else {
//   agApi = 'https://aguat.ak47-ag1ct.com'
// }

axiosIns.interceptors.request.use(
  async config => {
    // const currentOrigin = window.origin
    // const newSubdomain = "dev"

    if (window.origin.includes('localhost')) {
      config.baseURL = 'http://localhost:4040/api'

      // DEV
      localStorage.setItem('agent_id', 8)
    } else {
      const { origin } = window
      const url = new URL(origin)
      let prefix

      if (url.toString().includes('pgsoft-th') || url.toString().includes('narita888')) {
        prefix = 'adminapi'
      } else {
        prefix = 'api'
      }

      // console.log(url)
      if (hasSubdomain(url)) {
        url.hostname = url.hostname.replace(/^[^.]*/, prefix)
      } else {
        url.hostname = `${prefix}.${url.hostname}`
      }

      // const updatedUrl = url.replace(/^[^.]*/, prefix);
      const endpoint = `${url.toString()}api`

      config.baseURL = endpoint
      localStorage.setItem('endpoint', endpoint)
    }
    // response.data.endpoint
    // eslint-disable-next-line no-param-reassign
    // config.baseURL = response.data.endpoint
    // config.baseURL = window.origin.includes('localhost')
    //   ? 'http://localhost:4040/api'
    //   : response.data.endpoint
    // await axios
    //   .get(
    //     `${agApi}/api/agent/getEndpoint${
    //       window.origin.includes('localhost') ? '?agent_id=3' : ''
    //     }`,
    //   )
    //   // eslint-disable-next-line no-unused-vars
    //   .then(response => {
    //     localStorage.setItem('endpoint', response.data.endpoint)
    //     // response.data.endpoint
    //     // eslint-disable-next-line no-param-reassign
    //     // config.baseURL = response.data.endpoint
    //     config.baseURL = window.origin.includes('localhost')
    //       ? 'http://localhost:4040/api'
    //       : response.data.endpoint
    //   })
    //   .catch(error => console.log(error))
    // console.log(config.headers.Authorization)
    return config
  },
  error => Promise.reject(error),
)

function hasSubdomain(url) {
  try {
    const { hostname } = new URL(url)
    const parts = hostname.split('.')

    return parts.length > 2
  } catch (err) {
    return false
  }
}

// function getEndpoint() {
// const url = new URL(window.origin);

// if(url.includes('bk')) {
//   return
// }
// try {
//   const urlObj = new URL(window.origin)
//   const domainParts = urlObj.hostname.split('.')

//   if (domainParts.length > 2) {
//     domainParts[0] = 'api'
//   } else {
//     domainParts.unshift('api')
//   }

//   urlObj.hostname = domainParts.join('.')

//   console.log(`${urlObj.protocol}//${urlObj.hostname}/api`)
//   return `${urlObj.protocol}//${urlObj.hostname}/api`
// } catch (e) {
//   console.error('Invalid URL')
//   return null
// }
// }

Vue.prototype.$http = axiosIns

export default axiosIns
